/**
 * Juros e multa de atraso do boleto: tetos do servidor e leitura do texto
 * digitado. Mesmas regras de `apps/mobile/src/lib/billetLateCharges.ts` — o
 * servidor valida de novo (MAX_PENALTY_PERCENT / MAX_MONTHLY_INTEREST_PERCENT).
 */

export const MAX_PENALTY_PERCENT = 2;
export const MAX_INTEREST_PERCENT = 1;

export const PERCENT_FORMAT_MESSAGE = 'Informe apenas números.';
export const PENALTY_RANGE_MESSAGE = 'A multa vai de 0% a 2%.';
export const INTEREST_RANGE_MESSAGE = 'Os juros vão de 0% a 1% ao mês.';

// Dígitos com vírgula ou ponto opcional: "2", "1,5", "1.5", ",5".
const PERCENT_PATTERN = /^(\d+[.,]?\d*|[.,]\d+)$/;

/**
 * "1,5" e "1.5" viram 1.5. Vazio vira null (não informado); texto que não é
 * número vira NaN.
 */
export function parsePercent(text: string): number | null {
  const trimmed = (text ?? '').trim();
  if (!trimmed) return null;
  if (!PERCENT_PATTERN.test(trimmed)) return Number.NaN;
  return Number(trimmed.replace(',', '.'));
}

/**
 * Mensagem de erro do campo, ou null quando vale. Vazio vale: significa "não
 * informado" (usa o padrão da conta).
 */
export function percentError(text: string, max: number, rangeMessage: string): string | null {
  const parsed = parsePercent(text);
  if (parsed === null) return null;
  if (Number.isNaN(parsed)) return PERCENT_FORMAT_MESSAGE;
  if (parsed > max) return rangeMessage;
  return null;
}
